// extracted by mini-css-extract-plugin
module.exports = {"container":"VIP_ProductCommentItem__container","button":"VIP_ProductCommentItem__button"};